import { MonitoringState, RootState } from "@/@types/vuex";
import { GetterTree } from "vuex";

const getters: GetterTree<MonitoringState, RootState> = {
  farmGeometries: (state: MonitoringState) => state.farmGeometries,
};

export default getters;
